module.exports = __webpack_public_path__ + "img/adminD 3.6fdeab16.jpg";